module.exports = __webpack_public_path__ + "img/okgreen.06babe56.svg";